import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import modalError from './modal-error/reducer';
import voucher  from "./vouchers/reducer";
import extratos  from "./extratos/reducer";

const reducers = combineReducers({
    modalError,
    voucher,
    extratos
})

const store = createStore(
    reducers,
    applyMiddleware(thunk),
);


export { store }
